import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.003 5.997","key":"svg-0"}],["path",{"d":"M19 16l-2 3h4l-2 3","key":"svg-1"}]]

const IconHeartBolt = createReactComponent('outline', 'heart-bolt', 'HeartBolt', __iconNode);

export default IconHeartBolt;